import { OneModal } from '@yy/one-ui'
import React, { useMemo, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './index.module.less'

export function useModalImgPreview() {
  const { t } = useTranslation()

  const [modalVisible, setModalVisible] = useState(false)

  const [modalImgUrl, setModalImgUrl] = useState('')

  const [modalWidth, setModalWidth] = useState(0)

  const showPreviewModal = useCallback((url: string) => {
    const img = new Image()
    img.src = url
    img.onload = (e) => {
      setModalWidth((e?.target as HTMLImageElement).width + 48 || 600)
      setModalImgUrl(url)
      setModalVisible(true)
    }
  }, [])

  const previewModal = useMemo(() => {
    return (
      <OneModal
        width={modalWidth}
        title={t('notify.oldImage')}
        visible={modalVisible}
        footer={null}
        onCancel={() => {
          setModalVisible(false)
        }}
      >
        <img className={styles.modalImg} src={modalImgUrl}></img>
      </OneModal>
    )
  }, [modalImgUrl, modalVisible, modalWidth, t])

  return {
    showPreviewModal,
    previewModal,
  }
}
